"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGatewayAccountsByGatewayId = exports.getGatewayAccounts = exports["default"] = void 0;

var _reselect = require("reselect");

var _activePortal = require("../activePortal");

var _accounts = require("./accounts.actions");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var accountsById = function accountsById() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _activePortal.CHANGE_ACTIVE_PORTAL:
      {
        return {};
      }

    case _accounts.FIND_ALL_GATEWAY_ACCOUNTS_BY_PORTALID_SUCCESS:
      {
        var accounts = action.body.accounts;
        var newState = accounts.reduce(function (result, account) {
          var existingAccount = state[account.id];
          result[account.id] = _objectSpread(_objectSpread({}, existingAccount), account);
          return result;
        }, {});
        return _objectSpread(_objectSpread({}, state), newState);
      }

    default:
      {
        return state;
      }
  }
};

var validateReducer = function validateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _activePortal.CHANGE_ACTIVE_PORTAL:
      {
        return {};
      }

    default:
      {
        return state;
      }
  }
};

var allAccountIds = function allAccountIds() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _activePortal.CHANGE_ACTIVE_PORTAL:
      {
        return [];
      }

    case _accounts.FIND_ALL_GATEWAY_ACCOUNTS_BY_PORTALID_SUCCESS:
      {
        var accounts = action.body.accounts;
        var newState = accounts.reduce(function (result, account) {
          if (!state.some(function (accountId) {
            return accountId === account.id;
          })) {
            result.push(account.id);
          }

          return result;
        }, []);
        return [].concat(_toConsumableArray(state), _toConsumableArray(newState));
      }

    default:
      {
        return state;
      }
  }
};

var getGatewayAccounts = (0, _reselect.createSelector)([function (state) {
  return state.gatewayAccounts.allIds;
}, function (state) {
  return state.gatewayAccounts.byId;
}], function (allIds, accounts) {
  return allIds.map(function (id) {
    return accounts[id];
  });
});
exports.getGatewayAccounts = getGatewayAccounts;
var getGatewayAccountsByGatewayId = (0, _reselect.createSelector)([getGatewayAccounts, function (_, props) {
  return props.gatewayId;
}], function (allAccounts, gatewayId) {
  return allAccounts.filter(function (account) {
    return account.gatewayId === gatewayId;
  });
});
exports.getGatewayAccountsByGatewayId = getGatewayAccountsByGatewayId;
var _default = {
  byId: accountsById,
  allIds: allAccountIds,
  validate: validateReducer
};
exports["default"] = _default;